import { ColorProduct } from '~/components/UI/ColorsProduct'

export function getCurrentColor(colors: ColorProduct[]): ColorProduct {
  return colors?.find(({ current }) => current) ?? null
}
